import { CommissionsKpiGrid } from '@/components/Dashboard/CommissionsKpiGrid'
import { CommissionsRecentTable } from '@/components/Dashboard/CommissionsRecentTable'
import type { CommissionsTabView } from '@/components/Dashboard/commissionsTab.utils'

type Props = {
  view: CommissionsTabView
  valuesVisible?: boolean
}

export function CommissionsTab({ view, valuesVisible = false }: Props) {
  return (
    <div className='space-y-6'>
      <p className='text-sm text-text-muted'>
        Visão consolidada de comissões sobre deals ganhos no período — indicadores para admin e
        financeiro acompanhar volume, status e ranking por closer.
      </p>

      <CommissionsKpiGrid view={view} valuesVisible={valuesVisible} />
      <CommissionsRecentTable view={view} valuesVisible={valuesVisible} />
    </div>
  )
}
